import { createSlice } from "@reduxjs/toolkit";

export const NotificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
  },
  reducers: {
    saveNotificationsData: (state, action) => {
      state.notifications = action.payload;
    }
  }
});

export const { saveNotificationsData } = NotificationsSlice.actions;
export default NotificationsSlice.reducer;